module.exports = __webpack_public_path__ + "img/9788990220806.4c2bd916.jpg";